// =========================
// INFOCRAFTPC CONFIGURATOR
// Version optimisée & stable
// =========================

document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("[id^='icpcCustomQuoteForm']");
  if (!form) return;

  // ====== Elements ======
  const stepsContainer = form.querySelector("[data-icpc-steps]");
  const panels = [...stepsContainer.querySelectorAll(".icpc-step-panel")];
  const nextBtn = form.querySelector("[data-icpc-next]");
  const prevBtn = form.querySelector("[data-icpc-prev]");
  const counterEl = form.querySelector("[data-icpc-counter]");
  const progressBar = form.querySelector("[data-icpc-progress]");
  const stepLabels = form.querySelectorAll("[data-icpc-step-label]");
  const submitBtn = form.querySelector("[data-icpc-submit]");
  const hp = form.querySelector(".icpc-hp input");
  const elapsedField = form.querySelector("[id^='icpc-elapsed']");
  const fileInput = form.querySelector(".icpc-input-file");
  const fileLabel = form.querySelector("[data-icpc-file-label]");
  const filePreview = form.querySelector("[data-icpc-file-preview]");

  // ====== State ======
  const totalSteps = panels.length;
  let currentStep = 1;
  const startTime = Date.now();

  // ====== STEP MANAGEMENT ======
 const showStep = (step) => {
  currentStep = Math.max(1, Math.min(step, totalSteps));

  // Affichage du bon panneau
  panels.forEach(panel =>
    panel.classList.toggle("is-active", parseInt(panel.dataset.step, 10) === currentStep)
  );

  // Texte "Étape X sur Y"
  if (counterEl) {
    counterEl.textContent = `Étape ${currentStep} sur ${totalSteps}`;
  }

  // Barre de progression
  if (progressBar) {
    progressBar.style.width = (currentStep / totalSteps) * 100 + "%";
  }

  // Labels d'étapes actifs
  stepLabels.forEach(label => {
    label.classList.toggle(
      "is-active",
      parseInt(label.dataset.icpcStepLabel, 10) === currentStep
    );
  });

  // Boutons nav
  prevBtn.disabled = currentStep === 1;
  nextBtn.style.display = currentStep === totalSteps ? "none" : "inline-flex";
  submitBtn.style.display = currentStep === totalSteps ? "block" : "none";

  // 🔝 Scroll automatique en haut du configurateur
  const sectionEl = form.closest(".icpc-quote");
  if (sectionEl) {
    window.scrollTo({
      top: sectionEl.offsetTop - 10, // ajuste -10 si tu veux plus haut / plus bas
      behavior: "smooth"
    });
  }
};


  const validateStep = () => {
    const panel = panels.find(p => p.classList.contains("is-active"));
    const required = [...panel.querySelectorAll("[required]")];
    let valid = true;

    required.forEach(field => {
      field.classList.remove("icpc-input--error");
      if (!field.checkValidity()) {
        valid = false;
        field.classList.add("icpc-input--error");
      }
    });

    if (!valid) required[0].reportValidity?.();
    return valid;
  };

  // Buttons
  nextBtn.addEventListener("click", () => {
    if (!validateStep()) return;
    showStep(currentStep + 1);
  });

  prevBtn.addEventListener("click", () => showStep(currentStep - 1));

  showStep(currentStep);

  // ====== SUMMARY ======
  const summaryTargets = {};
  form.querySelectorAll("[data-icpc-summary]").forEach(el => {
    summaryTargets[el.dataset.icpcSummary] = el;
  });

  const updateSummary = (key, value) => {
    const el = summaryTargets[key];
    if (!el) return;
    el.textContent = value && value.trim() !== "" ? value : "Non renseigné";
  };

  // Special summaries (logiciels, stockage)
  const refreshSoftware = () => {
    const cbs = form.querySelectorAll("input[data-summary-key='Logiciels']:checked");
    const list = [...cbs].map(cb =>
      cb.closest(".icpc-option-card").querySelector(".icpc-card-title").textContent.trim()
    );
    updateSummary("Logiciels", list.length ? list.join(", ") : "Non renseigné");
  };

  const refreshStorage = () => {
    const ssd = form.querySelector("input[name='contact[Stockage SSD]']:checked");
    const hdd = form.querySelector("input[name='contact[Stockage HDD]']:checked");
    const txt = `${ssd ? "SSD " + ssd.value : ""} ${hdd ? " / HDD " + hdd.value : ""}`.trim();
    updateSummary("SSD/HDD", txt || "Non renseigné");
  };

  // Bind summary updates
  form.querySelectorAll("[data-summary-key]").forEach(input => {
    input.addEventListener("change", () => {
      const key = input.dataset.summaryKey;

      if (key === "Logiciels") return refreshSoftware();
      if (key === "SSD" || key === "HDD") return refreshStorage();

      let value = input.value;
      if (input.type === "radio" && input.closest(".icpc-option-card")) {
        const label = input.closest(".icpc-option-card").querySelector(".icpc-card-title");
        value = label ? label.textContent.trim() : input.value;
      }
      updateSummary(key, value);
    });

    if (["text","email","tel"].includes(input.type))
      input.addEventListener("keyup", () => updateSummary(input.dataset.summaryKey, input.value));
  });

  refreshSoftware();
  refreshStorage();

  // ====== FILE PREVIEW ======
  if (fileInput && fileLabel && filePreview) {
    fileInput.addEventListener("change", () => {
      filePreview.innerHTML = "";
      const file = fileInput.files?.[0];

      if (!file) {
        fileLabel.textContent = "Choisir une image";
        return;
      }

      fileLabel.textContent = file.name;
      if (file.type.startsWith("image")) {
        const reader = new FileReader();
        reader.onload = e => {
          filePreview.innerHTML = `<img src="${e.target.result}" alt="preview">`;
        };
        reader.readAsDataURL(file);
      }
    });
  }

  // ====== AUTOSAVE ======
  const storageKey = `icpcQuote_${form.id}`;
  const inputs = form.querySelectorAll("input[name^='contact['], textarea[name^='contact[']");

  const saveData = () => {
    const data = {};
    inputs.forEach(el => {
      if (!el.name) return;

      if (el.type === "radio") {
        if (el.checked) data[el.name] = el.value;
      } else if (el.type === "checkbox") {
        if (!data[el.name]) data[el.name] = [];
        if (el.checked) data[el.name].push(el.value);
      } else if (el.type !== "file") {
        data[el.name] = el.value;
      }
    });

    localStorage.setItem(storageKey, JSON.stringify(data));
  };

  const restoreData = () => {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return;

    let data;
    try { data = JSON.parse(raw); } catch { return; }

    inputs.forEach(el => {
      if (!(el.name in data)) return;

      const val = data[el.name];
      if (el.type === "radio" || el.type === "checkbox") {
        el.checked = Array.isArray(val) ? val.includes(el.value) : el.value === val;
      } else if (el.type !== "file") {
        el.value = val;
      }
    });
  };

  restoreData();
  inputs.forEach(el => {
    if (el.type !== "file") {
      el.addEventListener("change", () => saveData());
      el.addEventListener("keyup", () => saveData());
    }
  });

  // ====== SUBMIT ======
  form.addEventListener("submit", (e) => {
    // Honeypot anti-spam
    if (hp && hp.value.trim() !== "") {
      e.preventDefault();
      return;
    }

    // Elapsed time
    if (elapsedField) {
      elapsedField.value = Math.round((Date.now() - startTime) / 1000).toString();
    }

    // Disable submit button
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = "Envoi en cours…";
    }

    localStorage.removeItem(storageKey);
  });
});
